(function () {
  'use strict';

  /* @ngdoc object
   * @name dms
   * @description
   *
   */
  angular
    .module('dms', [
      'ui.router',
      'dms.scan',
      'dms.signoff'
    ]);
}());
